(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-custom-collage"]) return;
  try {
    
  if(document.querySelector(".custom-collage-section--product-container")){
    document.querySelector(".custom-collage-section--product-container").appendChild(document.querySelector(".custom-collage-section").closest(".shopify-section"));
  }

  } catch(e) { console.error(e); }
})();
})();
